import React, { Suspense, lazy } from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Login from './components/auth/Login';
import PublicLayout from './components/public/PublicLayout';
import RankingsPage from './components/public/RankingsPage';

const DashboardLayout = lazy(() => import('./components/layout/DashboardLayout'));
const ListsPage = lazy(() => import('./components/lists/ListsPage'));
const ListDetailPage = lazy(() => import('./components/lists/ListDetailPage'));
const SettingsPage = lazy(() => import('./components/settings/SettingsPage'));
const InsightsPage = lazy(() => import('./components/public/InsightsPage'));

const PageLoader = () => (
  <div className="d-flex justify-content-center align-items-center vh-100">
    <div className="spinner-border text-success" role="status" />
  </div>
);

const PrivateRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();
  if (loading) {
    return <PageLoader />;
  }
  return isAuthenticated ? children : <Navigate to="/admin/login" replace />;
};

const AppRoutes = () => (
  <Suspense fallback={<PageLoader />}>
    <Routes>
      <Route path="/" element={<Navigate to="/rankings" replace />} />
      <Route path="/admin/login" element={<Login />} />
      <Route path="/rankings" element={<PublicLayout />}>
        <Route index element={<RankingsPage />} />
        <Route path="insights" element={<InsightsPage />} />
        <Route path=":id" element={<Navigate to="/rankings" replace />} />
      </Route>
      <Route
        path="/admin"
        element={
          <PrivateRoute>
            <DashboardLayout />
          </PrivateRoute>
        }
      >
        <Route index element={<Navigate to="/admin/lists" replace />} />
        <Route path="lists" element={<ListsPage />} />
        <Route path="lists/:id" element={<ListDetailPage />} />
        <Route path="settings" element={<SettingsPage />} />
      </Route>
      <Route path="*" element={<Navigate to="/rankings" replace />} />
    </Routes>
  </Suspense>
);

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
